import PropTypes from 'prop-types';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import 'react-loading-skeleton/dist/skeleton.css';

import { useTheme } from '../../hooks/useTheme';

const SkeletonLoader = ({ height, width, baseColor, highlightColor }) => {
  const { colors } = useTheme();

  return (
    <SkeletonTheme baseColor={baseColor || colors.grey30} highlightColor={highlightColor || colors.grey100}>
      <Skeleton height={height} width={width} />
    </SkeletonTheme>
  );
};

SkeletonLoader.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  baseColor: PropTypes.string,
  highlightColor: PropTypes.string,
};

SkeletonLoader.defaultProps = {
  height: null,
  width: '100%',
  baseColor: null,
  highlightColor: null,
};

export { SkeletonLoader };
